// The backend force-ends impersonation (reverting us to our own session) when support access expires,
// and marks that response with this header so we can recover instead of looping through the login redirect.
export const IMPERSONATION_ENDED_HEADER = 'X-Impersonation-Ended';

const SESSION_FLAG_KEY = 'impersonation-ended-reason';

let handling = false;

// Reads the impersonation-ended marker from a fetch Response, returning the reason or null.
export function getImpersonationEndedReason(response: Response | null | undefined): string | null {
  return response?.headers?.get(IMPERSONATION_ENDED_HEADER) ?? null;
}

// We are already reverted to our own session server-side; stash the reason and reload as ourselves so the
// cached identity and impersonation banner reset cleanly. Guarded so concurrent failures navigate only once.
export function handleImpersonationEnded(reason: string): void {
  if (handling) {
    return;
  }
  handling = true;
  try {
    window.sessionStorage.setItem(SESSION_FLAG_KEY, reason);
  } catch {
    /* ignore storage failures */
  }
  window.location.assign('/');
}

// Reads and clears the stashed reason so the message is shown exactly once after the reload.
export function consumeImpersonationEndedReason(): string | null {
  try {
    const reason = window.sessionStorage.getItem(SESSION_FLAG_KEY);
    if (reason) {
      window.sessionStorage.removeItem(SESSION_FLAG_KEY);
    }
    return reason;
  } catch {
    return null;
  }
}
